import { Component, OnInit } from '@angular/core'
import { RegionService } from './_services/region.service'
import { TranslocoService } from '@jsverse/transloco'
import { Router } from '@angular/router'
import { SiteLogPollRouteService } from './_services/site-log-poll-route.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'speedbox-bo'

  constructor(
    private regionService: RegionService,
    private translocoService: TranslocoService,
    private router: Router,
    private siteLogPollRouteService: SiteLogPollRouteService
  ) {
    const browserLang = navigator.language
    if (this.translocoService.isLang(browserLang)) {
      this.translocoService.setActiveLang(browserLang)
    }
  }

  async ngOnInit(): Promise<void> {
    await this.interceptHardReset()
    this.regionService.init()
    // siteLogPollRouteService is injected to start route-based site log poll (subscribes in constructor)
    void this.siteLogPollRouteService
  }

  async interceptHardReset() {
    const wasHardReset = sessionStorage.getItem('wasHardReset')
    if (wasHardReset) {
      await this.router.navigateByUrl('/auth/hard-reset')
    }
  }
}
